//newChat.js
import React from 'react'
import upload from '../../Assets/upload.png'

import './NewChat.css'
import axios from 'axios';
import { useDispatch } from "react-redux"
import { useSelector } from 'react-redux'
import { useEffect, useState, useRef, useCallback } from 'react'
import { setChat } from '../../Redux/Actions';
import { updateChatData, getLLmOutput, getChatData, getChatHistory, createChatData, getLLmStreamOutput, billUpload, createChatFeedback } from '../../services/chatServices';
import { updateChat, modelState, sidebarState, ChatID, chatHistoryState } from '../../Redux/Actions'
import { ChatState } from '../../Redux/Actions'
import Avatar from '../../Assets/Avatar.png'
import logoImage from '../../Assets/logo-img.png'
import dropDown from '../../Assets/dropDown.png'
import search from '../../Assets/search.png'
import Group from '../../Assets/Group.png'
import copyBtn from '../../Assets/copy-btn.png'
import refresh from '../../Assets/refresh.png'
import thumbsDown from '../../Assets/thumbs-down.png'
import thumbsUp from '../../Assets/thumbs-up.png'
import thumbsUpVote from '../../Assets/thumbsUpVote.png'
import thumbsDownVote from '../../Assets/thumbsDownVote.png'
import speaker from '../../Assets/volume-max.png'
import user from '../../Assets/user.png'
import zap from '../../Assets/zap.png'
import line from '../../Assets/Line.png'
import openSidebar from '../../Assets/openSidebar.svg'
import closeSidebar from '../../Assets/closeSidebar.svg'
import attachFile from '../../Assets/paperclip.svg'
import open from '../../Assets/open.svg'
import close from '../../Assets/Close.svg'
import dropdown from '../../Assets/dropDown.png'
import edit from '../../Assets/editBlack.png'
import fileIcon from '../../Assets/FileUploadIcon.svg'
import { buttonClicked, setClicked } from '../Chat/Chat'
import Markdown from 'markdown-to-jsx'
// import ReactMarkdown from 'react-markdown';
import { useSpeechSynthesis } from 'react-speech-kit';
import { useOverflowDetector } from 'react-detectable-overflow';
import cross from '../../Assets/cross.svg';

let count, count1 = 0

const setCount = (newValue) => {
  count1 = newValue;
};

let sideBar = false

// const setSidebar = (toggle) =>
//   {
//     sideBar = toggle;
//  }
export { count1, setCount }
// export { sideBar ,setSidebar}
export default function NewChat({ recentChat, triggerEffect }) {
  // const fileInputRef = useRef(null);
  // const textareaRef = useRef(null);
  const fileUploadButtonRef = useRef(null);
  const dispatch = useDispatch();
  const [messages, setMessages] = useState([])
  const [chatIDs, setChatIds] = useState();
  const [history1, setHistory1] = useState([]);
  const [chathistory1, setchatHistory1] = useState([]);
  const [iconVisible, setIconVisible] = useState(false);
  const [isButtonVisible, setButtonVisible] = useState(true);
  const [userInput, setUserInput] = useState([]);
  const [userPrompt, setUserPrompt] = useState('');
  const [response1, setUserResponse] = useState([]);
  // const [chatBoxRef, setChatBoxRef] = useState(null);
  // const [count1, setCount1] = useState(0)
  const [isClicked, setIsClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [sideBar, setSideBar] = useState('');
  const chatBoxRef = useRef(null);
  // const { ref, overflow } = useOverflowDetector({});
  const [messages1, setMessages1] = useState([]);
  const [error1, setError1] = useState();
  const [inputPrompt, setInputPrompt] = useState();
  const [fileSize, setFileSize] = useState();
  // const [color, setColor] = useState([]);
  const { ref: overflowRef } = useOverflowDetector({});
  const [textareaHeight, setTextareaHeight] = useState('3.5rem');
  const textareaRef = useRef(null);
  const [colorState, setColor] = useState([]);
  const [response, setResponse] = useState("");
  const [streamResponse, setStreamResponse] = useState([]);
  const [prompt1, setPrompt1] = useState("");
  const [chatId1, setChatId1] = useState("");
  const [convId, setConvId] = useState("");
  const [loader, setLoader] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [count1, setCount1] = useState(0)
  const [responses, setResponses] = useState([]); // Responses for each message
  const [placeholder, setPlaceholder] = useState("")
  // const utf8=require('utf8')
  // const [triggerEffect, setTriggerEffect] = useState(false);
  let messageObj = []
  let responseData
  let responseText = '';
  let history, chatId
  let prompt

  let b1 = "Why my battery is not charging?"
  let b2 = "Give me list of my open complaints"
  let b3 = "What's my current battery percentage?"
  let b4 = "Is my battery currently charging?"
  let defaultClicked = false
  let updatedShowRed
  const flag = useSelector(state => state.userReducer)
  const chat = useSelector(state => state.chatReducer)
  const [isHovered, setIsHovered] = useState(false);
  const [showRed, setShowRed] = useState([]);
  const combinedChatBoxRef = useCallback(
    node => {
      if (node !== null) {
        // Assign node to both refs
        chatBoxRef.current = node;
        overflowRef.current = node;

        // Check if overflow is detected and toggle visibility
        const hasOverflow = node.scrollHeight > node.clientHeight;
        const hrContainer = node.parentNode.querySelector('.hr-container');

        if (hrContainer) {
          hrContainer.style.display = hasOverflow ? 'block' : 'none';
        }
      }
    },
    [overflowRef]
  );

useEffect(() => {
  console.log("isButtonVisible",isButtonVisible)
  if(isButtonVisible == true){
    setChatId1('')
    chatData.chatID=''
  }
},[isButtonVisible])



  useEffect(() => {
    scrollToBottom();

  }, [messages1, response1,responses]);

  useEffect(() => {

}, [messages]);

useEffect(() => {

}, [response]);

  // Function to scroll chatbox to bottom

  //// function for animation
  // useEffect(() => {
  //   setCompletedTyping(false);
  
  //   let i = 0;
  //   const stringResponse = chatHistory[chatHistory.length - 1].content
  
  //   const intervalId = setInterval(() => {
  //     setDisplayResponse(stringResponse.slice(0, i));
  
  //     i++;
  //     if (i > stringResponse.length) {
  //       clearInterval(intervalId);
  //       setCompletedTyping(true);
  //     }
  //   }, 20);
  
  //   return () => clearInterval(intervalId);
  // }, [chatHistory]);


  const scrollToBottom = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  };

  const handleHover = () => {
    setIsHovered(!isHovered);

  };
  const [isHoveredDropdown, setIsHoveredDropdown] = useState(false);
  const handleHoverDropdown = () => {
    setIsHoveredDropdown(!isHoveredDropdown);

  };
  const chatData = useSelector(state => state.chatReducer)


  const options = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token
    }
  };

  useEffect(() => {
    // If recentChat is false, clear the arrays
    if (chatData.model != '') {
      setSelectedOption(chatData.model)
    }
  });

  // const updateArray = (condition) => {
  //   setShowRed((prevArray) => {
  //     return [...prevArray, condition ? true : false];
  //   });
  // };

  useEffect(() => {

  }, [showRed]);

  useEffect(() => {
    // When the button is rendered, move the cursor below it
    if (textareaRef.current) {
      textareaRef.current.value = text + '\n\n'; // Add newlines to move the cursor down
      textareaRef.current.selectionStart = textareaRef.current.selectionEnd = textareaRef.current.value.length;
      textareaRef.current.focus();
    }
  }, [userInput]);

  function updatePlaceholder() {
     if(window.innerWidth > 917){
      setPlaceholder("Message SkyElectric Chatbot...")
     } 
      
     else{
      setPlaceholder("Message skyelectric Chatbot...")
     }
  }

  useEffect(() => {
    // Set initial placeholder
    updatePlaceholder();

    // Add event listener for window resize
    window.addEventListener("resize", updatePlaceholder);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updatePlaceholder);
  }, []);

  function findUnmatchedText(str1, str2) {
    // Split the strings into arrays of words
    const arr1 = str1.split(' ');
    const arr2 = str2.split(' ');

    // Find unmatched words
    const unmatchedInStr1 = arr1.filter(word => !arr2.includes(word));
    const unmatchedInStr2 = arr2.filter(word => !arr1.includes(word));

    // Convert arrays to strings
    const unmatchedInStr1String = unmatchedInStr1.join(' ');
    const unmatchedInStr2String = unmatchedInStr2.join(' ');

    return {
      unmatchedInStr1: unmatchedInStr1String,
      unmatchedInStr2: unmatchedInStr2String
    };
  }

  useEffect(() => {
    if (chatData.updateChat.length > 0) {
      const updatedData = chatData.updateChat.map(({ id, ...rest }) => rest);
      setMessages(updatedData);
    }
  }, [chatData.updateChat]); // Update messages when chatData.updateChat changes

  let messageData

  async function streamData(url, payload, headers) {
    try {
      const response = await axios.post(url, payload, {
        headers,
        // : {
        //   'Content-Type': 'application/json',
        //   ...headers,
        // },
        responseType: 'stream' // Ensure this if you're expecting streaming data
      });
  
      // Check if the response data is a stream
      if (response.data && typeof response.data.pipe === 'function') {
        const stream = response.data;
  
        stream.on('data', (chunk) => {
          // console.log('Chunk:', chunk.toString()); // Process each chunk of data
        });
  
        stream.on('end', () => {
          console.log('Stream completed.');
        });
  
        stream.on('error', (err) => {
          console.error('Stream error:', err);
        });
      } else {
        console.error('Response data is not a stream. Response Data:', response.data);
      }
  
    } catch (error) {
      console.error('Error:', error);
    }
  }
  
  async function processStream(reader) {
    const decoder = new TextDecoder();
  
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
  
      // Decode the chunk and log it to the console
      const chunk = decoder.decode(value, { stream: true });
      // console.log("Chunk:", chunk); // Log the chunk to the console
      // return chunk
    }
  }

  const [message1, setMessage] = useState('');
  const [currentMessage, setCurrentMessage] = useState('');

  
  // async function llmOutput(input, e) {

  //   e.preventDefault();
  //   // console.log("event",e)

  //   if (e.key === 'Enter' || e.type == 'click') {

  //     setUserInput(input)

  //     count += 1
  //     setCount(1)
  //     setButtonVisible(false)

  //     if (chatData.model == '') {
  //       chatData.model = 'SkyChat-instruct-0.1'

  //     }

  //     let updatedData, data
      
  //     data = {
  //       prompt: input,
  //       history: {
  //         messages
  //       },
     
  //         filter: chatData.model

  //     };

  //     data.history = JSON.stringify(data.history)

  //     document.getElementById('user-input').value = ''
  //     setFileName('');
  //     setUserInput('');

  //     let headers1 = {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //         // 'Content-Type': 'application/json',
  //         'Authorization': 'Bearer ' + localStorage.token
  //       },
  //       // responseType: 'stream'
  //     };
     
      
  //     try {

  //       let response;
     
  //         setResponses(prev => [...prev, { text: '', isStreaming: true }]);
  //         const requestBody = {
  //           prompt: input,  
         
  //           user_id:localStorage.userId,
  //           chat_id:null,
  //           filter: chatData.model  // Replace with your actual filter
  //       };
     
  //     const formData = new FormData();
  //     if(selectedFile){
  //         setUserInput(selectedFile.name)
  //         formData.append('file', selectedFile);
  //     }

  //     else{
  //       formData.append('prompt', input);
  //     }
      
  //     formData.append('user_id', localStorage.userId);
  //     formData.append('chat_id', null);  // Assuming `null` is acceptable
  //     formData.append('filter', chatData.model);
  //       response = await getLLmOutput(formData);

  //           const decoder = new TextDecoder();
  //       let accumulatedText = '';

  //       let done = false;
  //       let responseText = ''; // Ensure responseText is defined before use
        
  //       while (!done) {
  //         const { value, done: readerDone } = await response.read();
  //         done = readerDone;
  //         responseText += decoder.decode(value);
        
  //         // Update the response for the last message
  //         setResponses(prev => {
  //           // console.log('Updating responses with:', responseText);
  //           const updatedResponses = [...prev];
  //           if (updatedResponses.length > 0) {
  //             updatedResponses[updatedResponses.length - 1] = { text: cleanText(responseText), isStreaming: true };
  //           } else {
  //             console.warn('No responses to update');
  //           }
  //           // console.log('Responses after update:', updatedResponses);
  //           return updatedResponses;
  //         });
  //       }
        
  //       // Mark the response as complete
  //       setResponses(prev => {
  //         // console.log('Finalizing responses with:', responseText);
  //         const updatedResponses = [...prev];
  //         if (updatedResponses.length > 0) {
  //           updatedResponses[updatedResponses.length - 1] = { text: cleanText(responseText), isStreaming: false };
  //         } else {
  //           console.warn('No responses to finalize');
  //         }
  //         // console.log('Responses after finalizing:', updatedResponses);
  //         return updatedResponses;
  //       });
        
     
  //       if (response != undefined) {
  //         if (selectedFile){
  //           responseData = response
  //         }

  //         else{
  //           responseData = responseText
  //         }
       
  //         setUserResponse([...response1, responseData])

  //         setIconVisible(!iconVisible);
  //         setColor(colorState => [...colorState, false]);


  //         // scrollToBottom();

  //         let messages1 = []

  //         const mergedArray = [...messages1, history];

  //         setHistory1(mergedArray)

  //         setSelectedFile(null)


  //       }

  //       else {
  //         console.log("in error state", response)
  //       }

  //     } 
  //     catch (error) {

      
  //       setUserResponse([...response1, error.response.data.error])
  //       setError1(error.response.data.error)
  //       setColor(colorState => [...colorState, true]);
  //       // setColor(true)
  //       history = {
  //         query: data.prompt,
  //         response: error.response.data.error,
  //         role: localStorage.role,
  //         // color: 'red'
  //       }
        
  //       messageObj = [...messageObj, history]
  //       setMessages(messageObj => [...messageObj, history]);

  //       dispatch(setChat(messages))

  //       setSelectedFile(null)

  //     }

  //     return false;
  //   }

  // }
  const [cleanedText, setCleanedText] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const isValidMarkdown = (markdown) => {
    const markdownPattern = /(\#|\*\*|\*|~|`|\[.*?\]\(.*?\))/; // Example regex
    return markdown && markdownPattern.test(markdown);
  };

  async function llmOutput(input, e) {

    if (isDisabled) {
      e.preventDefault(); // Prevent actions when disabled
      return; // Exit the function
  }
    console.log("event",e)
    e.preventDefault();
  
    if (e.key === 'Enter' || e.type == 'click') {
      setIsDisabled(true);
      setCount(1);
      // Update state
      setUserInput(input);
      setUserPrompt(input)
      count += 1;
     // Ensure count is updated correctly
      setButtonVisible(false);
  
      // Set model if not set
      if (chatData.model === '') {
        chatData.model = 'SkyChat-instruct-0.1';
      }
  
      // Prepare data for request
      let updatedData, data;
      data = {
        prompt: input,
        history: {
          messages
        },
        filter: chatData.model
      };
      data.history = JSON.stringify(data.history);
  
      // Clear user input
      document.getElementById('user-input').value = '';
      setFileName('');
      setUserInput('');
  
      // Prepare headers and form data
      let headers1 = {
        headers: {
          'Content-Type': 'application/json',
          // 'Accept': "text/event-stream",
          //  'Accept': "text/event-stream",
          'Authorization': 'Bearer ' + localStorage.token
        }
      };
  
      let response;
      // try {
        setResponses(prev => [...prev, { response: '', query: userPrompt, id:'', isStreaming: true, loader:'' }]);
  
        const formData = new FormData();
        if (selectedFile) {
          formData.append('file', selectedFile);
        } 
        if(input) {
          formData.append('prompt', input);
        }
        
        // console.log("chatId1",chatId1)
        // console.log("loader",loader)
        // console.log("chatData.chatID",chatData.chatID)
        if(chatId1){
          // console.log("in 1st")
          formData.append('chat_id', chatId1);
        }

        else if(chatData.chatID){
          // console.log("in 2nd")
          formData.append('chat_id', chatData.chatID);
        }

        else if(isButtonVisible == true) {
          // console.log("in 3rd")
          formData.append('chat_id', '');
          
        }

        formData.append('user_id', localStorage.userId);    
        formData.append('filter', chatData.model);
  
        response = await getLLmOutput(formData);
        console.log("response123",response)
        const historyData = {
          user_id: localStorage.userId
        };
        // setTimeout(() => {
        
        
         
          
         
        // }, 1000);
        
        const decoder = new TextDecoder();

        let accumulatedText = '';
        let done = false;
        let responseText = '';
        let jsonData
console.log("convId",convId)
// Create a function to update responses
const updateResponses = (text, isStreaming) => {
  setResponses(prev => {
    const updatedResponses = [...prev];
    if (updatedResponses.length > 0) {
      updatedResponses[updatedResponses.length - 1] = { 
        response: cleanText(text), 
        query: userPrompt,
        isStreaming: isStreaming, 
        loader: loader ,
        id: convId
      };
    }
    return updatedResponses;
  });
};

// Start streaming
while (!done) {
  const { value, done: readerDone } = await response.read();
  done = readerDone;

  if (value) {
    responseText += decoder.decode(value, { stream: true });
    updateResponses(responseText, true); // Update state with current text
  }
}

// Finalize the response after reading is complete
updateResponses(responseText, false);

        if(responseText && !chatId1 && !chatData.chatID){
          // setTimeout(async () => {
            try {
                let response1 = await getChatHistory(historyData, options);
                console.log("response1", response1);
                dispatch(chatHistoryState(response1));
            } catch (error) {
                console.error("Error fetching chat history:", error);
            }
        // }, 2000);
        }

      //   setResponses(prev => {
      //     const updatedResponses = [...prev];
      //     if (updatedResponses.length > 0) {
      //         updatedResponses[updatedResponses.length - 1] = { text: cleanText(responseText), isStreaming: false, loader:loader };
      //     } else {
      //         console.warn('No responses to finalize');
      //     }
      //     return updatedResponses;
      // });
  
       
        let responseData;
        if (selectedFile) {
          responseData = response;
        } else {
          responseData = responseText;
        }
  
        setUserResponse(prev => [...prev, responseData]);
        setIconVisible(!iconVisible);
        setColor(prev => [...prev, false]);
        scrollToBottom();
  
        let messages1 = [];
        const mergedArray = [...messages1, history];
        setHistory1(mergedArray);
        setSelectedFile(null);
        setIsDisabled(false);
      // } catch (error) {
      //   setUserResponse(prev => [...prev, error.response.data.error]);
      //   setError1(error.response.data.error);
      //   setColor(prev => [...prev, true]);
      //   history = {
      //     query: data.prompt,
      //     response: error.response.data.error,
      //     role: localStorage.role
      //   };
  
      //   messageObj = [...messageObj, history];
      //   setMessages(prev => [...prev, history]);
      //   dispatch(setChat(messages));
      //   // setSelectedFile(null);
      // }
      
      return false;
    }
  }
  

  // function cleanText(text) {
  //   // Remove the 'data: ' prefix and quotation marks
  //   let cleanedText = text
  //     .replace(/data: /g, '') // Remove 'data: ' prefix
  //     .replace(/"/g, '');     // Remove quotation marks
  
  //   // Remove specific markers and metadata
  //   cleanedText = cleanedText
  //     .replace(/<se_start>Analyzing<se_end>/g, '')  // Remove specific markers
  //     .replace(/{chat_id: null}/g, '')              // Remove chat_id metadata
  //     .replace(/<done>Done<done>/g, '')             // Remove done markers
  //     .trim();  // Remove leading and trailing spaces
  
  //   // Replace multiple spaces with a single space
  //   cleanedText = cleanedText.replace(/\s{2,}/g, ' ');
  
  //   return cleanedText;
  // }

  function utf8Encode(str) {
    // Create a Uint8Array to hold the UTF-8 bytes
   
    const utf8Bytes = new TextEncoder().encode(str);
    return utf8Bytes;
}

// Function to convert a UTF-8 encoded array back to a string
function utf8Decode(bytes) {
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
}

  function cleanText(text) {
    // Remove the 'data: ' prefix and quotation marks
    let cleanedText = text
      .replace(/data: /g, '') // Remove 'data: ' prefix
      .replace(/"/g, '');     // Remove quotation marks
  
    // Remove specific markers and metadata
    cleanedText = cleanedText
    // .replace(/<se_start>.*?<se_end>/g, '')   // Remove specific markers
      .replace(/<done>Done<done>/g, '')             // Remove done markers
      // .replace(/(?:\s*,\s*)?chat_id\s*:\s*[^,}]+/g, '') // Remove chat_id and its value
      .replace(/(?:\s*,\s*)?chat_title\s*:\s*[^,}]+/g, '') // Remove chat_id and its value
      // .replace(/<se_start>Extracting Information<se_end>/g, '')  // Remove specific markers
      .replace(/{}/g, '') 
      // .replaceAll('\\n', '\n') 
      //  .replaceAll('\\', '\') 
      // .replaceAll('\\n', '\n') 
      
      .trim();  // Remove leading and trailing spaces
  
    // Replace multiple spaces with a single space
    // cleanedText = cleanedText.replace(/\s{2,}/g, ' ');
    // cleanedText = JSON.parse(JSON.stringify(cleanedText))
    // cleanedText = JSON.parse(JSON.stringify(cleanedText)); // Assuming this is necessary

// Convert to UTF-8
// const utf8Array = utf8Encode(cleanedText);
// const utf8Array = Buffer.from(JSON.stringify(cleanedText),"utf8")
// // If you need to convert it back to a string (optional)
// const utf8String = utf8Decode(utf8Array);

// console.log(utf8Array);  // Logs the UTF-8 byte array
// console.log(utf8String);
    return cleanedText;
}


  useEffect(() => {
    // This useEffect runs whenever colorState changes
  }, [colorState]);

  useEffect(() => {
   
  }, [error1]);

  // useEffect(() => {
  //   console.log("responses",responses)
  //   if(responses[0]){
  //     const chatId = responses[0].text.match(/chat_id: ([\w-]+)/);
  //     console.log("chatId",chatId);
  //   }
   
  // }, [responses]);

//   useEffect(() => {
//     console.log("responses", responses);
//     if (responses[0]) {
//         const chatIdMatch = responses[0].text.match(/chat_id: ([\w-]+)/);
//         console.log("chatIdMatch", chatIdMatch);
//         if (chatIdMatch) {
//             const chatId = chatIdMatch[1];
//             setChatId1(chatId)
//             // console.log("chatId", chatId);
//         }
//     }
// }, [responses,getChat]);


useEffect(() => {
  

  if(chat.ChatState == true){
    setResponses([])
    setChatId1('')
  }

  // setTimeout(() => {
    
  // }, 100);
  // console.log("responses from newchat",responses)
  },[chat.ChatState])

useEffect(() => {
 
  console.log("responses", responses);

  if (responses[responses.length-1]) {
      // Extract chat_id from the text
      const chatIdMatch = responses[responses.length-1].response.match(/chat_id: ([\w-]+)/);
      const convIdMatch = responses[responses.length-1].response.match(/conv_id: ([\w-]+)/);

      if (chatIdMatch && convIdMatch) {
          const chatId = chatIdMatch[1];
          const convId = convIdMatch[1]
          setChatId1(chatId);
          setConvId(convId)
          // Remove chat_id from the response text
          let cleanedText = responses[responses.length - 1].response
          .replace(/(?:\s*,\s*)?chat_id\s*:\s*[^,}]+/g, '')
          .replace(/(?:\s*,\s*)?conv_id\s*:\s*[^,}]+/g, '');

          setResponses(prev => {
              const updatedResponses = [...prev];
              if (updatedResponses.length > 0) {
                  updatedResponses[updatedResponses.length - 1] = { response: cleanText(cleanedText), query: userPrompt, id: convId,isStreaming: false };
              } else {
                  console.warn('No responses to update');
              }
              return updatedResponses;
          });
      }

      

      const regex = /<se_start>(.*?)<se_end>/;

      // Use the regex to extract the content
            const loader = responses[responses.length-1].response.match(regex);
      
            if (loader) {
              let convId
              if(convIdMatch){
                convId = convIdMatch[1]
              }
              
                // match[1] contains the content between <se_start> and <se_end>
                const loaderText = loader[1];
                // console.log("loader",loaderText)
                setLoader( loaderText);

                const cleanedLOaderText = responses[responses.length-1].response.replace(/<se_start>.*?<se_end>/g, '');

                setResponses(prev => {
                  const updatedResponses = [...prev];
                  if (updatedResponses.length > 0) {
                      updatedResponses[updatedResponses.length - 1] = { response: cleanText(cleanedLOaderText), query: userPrompt,id: convId, isStreaming: false, loader:loaderText };
                  } else {
                      console.warn('No responses to update');
                  }
                  return updatedResponses;
              });
                
            }
           
  }
}, [responses]);


  
useEffect(() => {
  if (chatId1 && responses[0]) {
      // Remove the chat_id from the text
      const updatedText = responses[0].response.replace(/(?:\s*,\s*)?chat_id\s*:\s*[^,}]+/g, '');
      // Clean the updated text
      const textToClean = cleanText(updatedText);
      setCleanedText(textToClean);
  }
}, [chatId1, responses]); 
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  async function createChat(history) {
    const uuid = uuidv4();
    const data = {
      user_id: localStorage.userId,
      chat_id: uuid,
      chat_messages: history
    }

    let response = await createChatData(data, options)
    chatId = response.data.chat_id

    setChatIds(chatId)
  }

  async function getChat() {
   
    count++
    let id_chat
    if (chatData.updateChat.length == undefined) {
      id_chat = chatId


    }

    else if (chatData.updateChat.length > 0 && chatData.chatID=='') {
      id_chat = chatData.chatID

    }

    else {
      id_chat = chatIDs

    }


    const data = {
      user_id: localStorage.userId,
      chat_id: id_chat
    };

    // console.log("id_chat",id_chat)
    setChatId1(id_chat)
    try {
      chatHistory = []
      const response = await getChatData(data, options);
      setchatHistory1(response.data.chat_history)
      dispatch(updateChat(response.data.chat_history))
      dispatch(ChatID(id_chat))

    } catch (error) {
      console.error("Error:", error);

    }

  }

  async function updateUserChat() {

    let id_chat, input

    if (userInput && selectedFile == null) {
      input = userInput

    }

    else if (userInput && selectedFile != null) {
      input = selectedFile.name + userInput
    }

    else if (selectedFile != null && !userInput) {
      input = selectedFile.name
    }

   
    id_chat = chatData.chatID

    let data
    if(selectedFile){
      data = {
        chat_id: id_chat,
        chat_messages: [
          {
            role: localStorage.role,
            query: input,
            response: responseData
          }
        ]
  
      };
    }

    else{
      data = {
        chat_id: id_chat,
        chat_messages: [
          {
            role: localStorage.role,
            query: input,
            response: responseText
          }
        ]
  
      };
    }
   

    try {
      const response = await updateChatData(data, options);;
      // setChatData(response);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  let chatHistory = chatData.updateChat
  let chatHistoryLength = chatData.updateChat.length
  


  // function defaultMessages(buttonVal, e) {
  //   console.log("in button func")
  //   setCount(1)
  //   setIsClicked(true)
  //   llmOutput(buttonVal, e)

  //    let inputObj = {
  //      defaultButton:true,
  //      buttonVal:buttonVal
  //     }
    
  //   setIsClicked(true);
  //   setTextareaHeight('auto');
  //   e.preventDefault();

  //   setMessages1([...messages1, inputObj]);

  //   setButtonVisible(false)

  // }

  function defaultMessages(buttonVal, e) {
    // console.log("in button func");  // Check if this is logged
    setChatId1('')
    setCount(1);
    setIsClicked(true);
    llmOutput(buttonVal, e);

    let inputObj = {
      defaultButton: true,
      buttonVal: buttonVal,
    };

    setTextareaHeight('auto');
    e.preventDefault();  // Prevent default action

    setMessages1((prevMessages) => [...prevMessages, inputObj]);  // Ensure state update
    setButtonVisible(false);
  }

  const [inputValue, setInputValue] = useState('');

  const [text, setText] = useState('');
  const [inputHeight, setInputHeight] = useState('auto');
  const [userInput1, setUserInput1] = React.useState("");
  const handleChange = (e) => {
    // setUserInput(e.target.value);
    const { value } = e.target;
    setUserInput(value);
  
    setInputValue(e.target.value);
    setText(e.target.value);

    const { selectionStart, selectionEnd } = e.target; // Get current selection
    setUserInput(e.target.value);
  
    // Use a timeout to ensure cursor position is set after state update
    setTimeout(() => {
      textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
    }, 0);

    const currentScrollHeight = e.target.scrollHeight;
    const currentClientHeight = e.target.clientHeight;
    //  document.getElementById('user-input').value=''

    const inputText = e.target.value;
    if (fileName && inputText.startsWith(fileName)) {
      setUserInput(inputText.slice(fileName.length).trimStart());
    } else {
      setUserInput(inputText);
    }
  };


  const handleFileUpload = (event) => {
    handleFileChange(event); // Call your existing file change handler

    // Ensure the textarea is visible below the file upload button
    if (textareaRef.current && fileUploadButtonRef.current) {
      textareaRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  };

  // const handleFileUpload = (event) => {
  //   console.log('File selected:', event.target.files[0]);
  // };


  const handleSubmit = (e) => {

    if (isDisabled) {
      return; // Prevent submission when disabled
  }
    e.preventDefault();
    // setCount(1);
    let input
    let inputObj
   

    if (inputValue) {
     
      input = inputValue


    }


    else if (selectedFile != null && !inputValue) {
     
      input = selectedFile.name
    }


    if (selectedFile != null && !inputValue) {
      inputObj = {
        fileUpload: true,
        fileSize: fileSize,
        inputTyped: false,
        fileValue: selectedFile.name
      }
      // setTextareaHeight('100px');
    }

    else if (selectedFile == null && inputValue) {
      inputObj = {
        fileUpload: false,
        inputTyped: true,
        typedValue: input

      }
    }

    else if (selectedFile != null && inputValue) {
      
      let resultString = inputValue.replace(selectedFile.name, '').trim();
      inputObj = {
        fileUpload: true,
        fileSize: fileSize,
        inputTyped: true,
        typedValue: resultString,
        fileValue: selectedFile.name

      }
      // setTextareaHeight('100px');
    }


    setIsClicked(true);
    setTextareaHeight('auto');
   
    if (input.trim() === '') return; // Don't submit empty messages

    setMessages1([...messages1, inputObj]);

    let queryData = []

    setInputValue('');
  };

//   const handleSubmit = (e) => {
//   e.preventDefault();
//   let input = inputValue.trim();
//   let inputObj = null;

//   if (input) {
//     inputObj = {
//       fileUpload: false,
//       inputTyped: true,
//       typedValue: input
//     };
//   } else if (selectedFile) {
//     inputObj = {
//       fileUpload: true,
//       fileSize: fileSize,
//       inputTyped: false,
//       fileValue: selectedFile.name
//     };
//   } else if (input && selectedFile) {
//     let resultString = input.replace(selectedFile.name, '').trim();
//     inputObj = {
//       fileUpload: true,
//       fileSize: fileSize,
//       inputTyped: true,
//       typedValue: resultString,
//       fileValue: selectedFile.name
//     };
//   }

//   if (inputObj) {
//     setMessages1([...messages1, inputObj]);
//     setInputValue('');
//     setSelectedFile(null); // Reset file selection
//   }
// };


  let queryData = []

  useEffect(() => {
    // If recentChat is false, clear the arrays
    if (!recentChat) {
      setMessages1([]);
      setUserResponse([]);
    }
  }, [recentChat, triggerEffect]);

useEffect(() => {
  // console.log("messages1",messages1)
},[messages1])
  const handleSelect = (event) => {
    event.preventDefault();
    const selected = event.target.textContent;
    setSelectedOption(selected);
    dispatch(modelState(selected));
  };


  const [hoveredButton, setHoveredButton] = useState({ index: null, button: null });
  const [index1, setIndex1] = useState(null);

  const handleMouseEnter = (index, button) => {
    setIndex1(index);
    setHoveredButton({ index, button });
  };

  const handleMouseLeave = () => {
    setIndex1(null);
    setHoveredButton({ index: null, button: null });
  };

  const [textToSpeak, setTextToSpeak] = useState('');

  const { speak } = useSpeechSynthesis();

  // const handleButtonClick = (response) => {
  //   console.log("response",response.length)
  //   const CHUNK_SIZE = response.length; // Adjust as needed
  //   const textChunks = response.match(new RegExp(`.{1,${CHUNK_SIZE}}`, 'g'));
  //   console.log("textChunks",textChunks)
  //   textChunks.forEach((chunk) => {
  //     speak({ text: chunk });
  //   });
  // };

 

  let isSpeaking = false;

  const handleButtonClick = async (response) => {
    response = response.replace(/<!-- hidden.*?-->/g, '');
    console.log("response123",response)
    const textChunks = response.split(/(?<=[.!?])\s+/); // Split by sentence
 
  
    for (const chunk of textChunks) {
      // Wait until TTS is not speaking
      while (isSpeaking) {
        await new Promise(resolve => setTimeout(resolve, 100)); // Wait
      }
  
      try {
        isSpeaking = true; // Set speaking state
        console.log("Speaking chunk:", chunk);
        await speak({ text: chunk });
      } catch (error) {
        console.error("Error speaking chunk:", error);
      } finally {
        isSpeaking = false; // Reset speaking state
      }
    }
  };
  
  
  
//   const simpleText = "Hello, this is a test.";
// handleButtonClick(simpleText);

  const InfiniteScroll = () => {
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


  }

  
  // function closeSideBar() {
  //   setSideBar(!sideBar)
  //   dispatch(sidebarState(sideBar))
  // }

  // function closeSideBar() {
  //   setSideBar((prevSideBar) => {
  //     const newSideBarState = !prevSideBar;
  //     dispatch(sidebarState(newSideBarState)); // Dispatch with the correct toggled state
  //     return newSideBarState;
  //   });
  // }

  // function closeSideBar(event) {
  //   event.stopPropagation();
  //   setSideBar((prevSideBar) => {
  //     const newSideBarState = !prevSideBar;
  //     dispatch(sidebarState(newSideBarState));
  //     return newSideBarState;
  //   });
  // }
  // function closeSideBar(event) {
  //   event.stopPropagation(); // Prevent parent elements from handling the event
  //   setSideBar((prevSideBar) => {
  //     const newSideBarState = !prevSideBar;
  //     dispatch(sidebarState(newSideBarState));
  //     return newSideBarState;
  //   });
  // }

  // function closeSideBar() {
  //   setSideBar((prevSideBar) => {
  //     const newSideBarState = !prevSideBar;
  //     dispatch(sidebarState(newSideBarState)); // Update Redux state
  //     return newSideBarState; // Update local state
  //   });
  // }

  function closeSideBar() {
    setSideBar((prevSideBar) => {
      let newSideBarState
      console.log("Dispatching new state:", newSideBarState);
      if(window.innerWidth <= 910){
        newSideBarState = true
      }

      else{
        newSideBarState = !prevSideBar;
      }
      dispatch(sidebarState(newSideBarState));
      return newSideBarState;
    });
  }
  
  
  
  
  

  function closeSideBar1() {

    setSideBar(prevSideBar => {
        const newSideBar = !prevSideBar;
        // console.log("sidebar in closebar func1", newSideBar);
        dispatch(sidebarState(newSideBar));
        
        // Perform your DOM manipulation here with the new value of sideBar
        if (newSideBar === true) { // Note: Using `true` if `newSideBar` is a boolean
            
            const element = document.getElementById("sidebarButton");
            if (element) {
                // element.style.marginTop = '40%';
            }
        }
        
        return newSideBar;
    });


}



  document.addEventListener('DOMContentLoaded', function () {
    const element = document.getElementById('chatBox');
    if (element) {
      const isScrollable = element.scrollHeight > element.clientHeight;
      if (isScrollable) {
        console.log('Vertical scrolling is enabled');
      } else {
        console.log('Vertical scrolling is not enabled');
      }
    } else {
      console.log('Element with ID "chatBox" not found');
    }
  });

  function auto_height(elem) {  /* javascript */

    elem.style.height = '0.063rem';
    elem.style.height = (elem.scrollHeight) + 'px'; // Corrected to concatenate properly
  }

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);
  const [matches, setMatches] = useState(window.matchMedia("(max-width: 917px)").matches);
  // const handleClick = () => {
   
  //   setIsVisible(true)
  //   fileInputRef.current.value = null;
  //   fileInputRef.current.click();

   
  // };

 

  const handleClick = (event) => {
    // event.stopPropagation();
    setIsVisible(true);
    if (fileInputRef.current) {
      fileInputRef.current.value = ''; // Clear previous file selection
      fileInputRef.current.click(); // Trigger file selection dialog
    }
  };
  
 
let mediaQuery
// useEffect(() => {
//   // Create a media query list
//   const mediaQueryList = window.matchMedia("(max-width: 917px)");

//   // Define a callback function to handle changes
//   const handleChange = (event) => {
//     setMatches(event.matches);
    

//     if(event.matches){
//       console.log("Media query matches:", event.matches);

//       closeSideBar1()
     
//     }

//     else{
//       console.log("Media query doesn't match:", event.matches);
//       setSideBar(true)
//       dispatch(sidebarState(true))
//       // closeSideBar()
//     }

//   };

//   // Attach the listener
//   mediaQueryList.addEventListener('change', handleChange);

//   // Cleanup function to remove the listener
//   return () => mediaQueryList.removeEventListener('change', handleChange);
// }, []);

useEffect(() => {
  // Create a media query list
  const mediaQueryList = window.matchMedia("(max-width: 917px)");

  // Define a callback function to handle changes
  const handleChange = (event) => {
    setMatches(event.matches);

    if (event.matches) {
      console.log("Media query matches:", event.matches);
      closeSideBar1(); // Custom function to close sidebar
    } else {
      console.log("Media query doesn't match:", event.matches);
      setSideBar(true);
      dispatch(sidebarState(true)); // Assuming you're dispatching the sidebar state
      // closeSideBar() // Optional: custom function to close sidebar
    }
  };

  // Attach the listener
  mediaQueryList.addEventListener('change', handleChange);

  // Initial check for window size
  handleChange(mediaQueryList); // Trigger the handler immediately on mount

  // Cleanup function to remove the listener
  return () => {
    mediaQueryList.removeEventListener('change', handleChange);
  };
}, [dispatch]);

// useEffect(() => {
//   console.log("Updated sidebar state", sideBar);
//   dispatch(sidebarState(sideBar));
// }, [sideBar]);

  
  useEffect(() => {
    if (textareaRef.current && fileUploadButtonRef.current) {
      textareaRef.current.style.paddingTop = fileName ? '5rem' : '1rem';
    }
  }, [fileName]);

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const fileSizeInBytes = file.size;
//       const fileSizeInKB = (fileSizeInBytes / 1024).toFixed(0);

//       setFileSize(fileSizeInKB)
//       setSelectedFile(file);
//       setFileName(file.name);

//       setUserInput('');
//       setTextareaHeight('110px');
//       event.target.value = null;

//       // setResponses([]);
// //       setUserResponse([]);
// // setColor([]);

//     }

//   };

// const handleFileChange = (event) => {
//   const file = event.target.files[0];
//   if (file) {
//     const fileSizeInBytes = file.size;
//     const fileSizeInKB = (fileSizeInBytes / 1024).toFixed(0);

//     setFileSize(fileSizeInKB);
//     setSelectedFile(file);
//     setFileName(file.name);

//     setUserInput('');
//     setTextareaHeight('110px');
//     // event.target.value = null; // Avoid clearing here
//   }
// };

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    const fileSizeInKB = (file.size / 1024).toFixed(0);
    setFileSize(fileSizeInKB);
    setSelectedFile(file);
    setFileName(file.name);
    setUserInput('');
    setTextareaHeight('110px'); // Adjust as needed
  }
};

const handleKeyPress = (e) => {
  if (isDisabled && e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault(); // Prevent form submission
  } else if (e.key === 'Enter' && !e.shiftKey) {
    e.preventDefault(); // Prevent the default action of a new line
    handleSubmit(e); // Call your submit function
  }
};




  const handleUpload = async () => {

    const formData = new FormData();
    formData.append('file', selectedFile);

    for (let [key, value] of formData.entries()) {
      console.log("formData:", key, value);
    }
    let headers1 = {
      'Content-Type': 'multipart/form-data',
      // 'Authorization': 'Bearer '+ localStorage.token
    }

    try {

      let response = await billUpload(formData, headers1);


    } catch (error) {
      console.error("Error:", error);
    }
  }

  const [isVisible, setIsVisible] = useState(true);

  // Handler to close the button
  const handleClose = () => {
    setIsVisible(false);
    // setFileName('');
    // setSelectedFile(null)

    setFileName('');
    setFileSize('');


  };

  const getHeight = () => {
    return fileName && isVisible ? '7rem' : '2.5rem';
  };

  const auto_grow = () => {
  const element = document.getElementById("user-input");
    if (element) {
        // console.log(element.scrollHeight)
         element.style.height = "5px";
         element.style.height = (element.scrollHeight+5) + "px";
    }
  }

  function formatText(text) {
    return text
        .replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>') // Convert bold syntax
        .replace(/(?:\r\n|\r|\n)/g, '<br>'); // Replace new lines with <br>
}

const [feedbackState, setFeedbackState] = useState({});
const [currentUpImage, setCurrentUpImage] = useState(false);
const [currentDownImage, setCurrentDownImage] = useState(false);
const [iconStates, setIconStates] = useState({});
const [submittedFeedback, setSubmittedFeedback] = useState({});
const [feedbackComment, setFeedbackComment] = useState({});
const [commentConfirmation, setCommentConfirmation] = useState();
const [flagValue, setFlagValue] = useState();
// const [submittedFeedbackBad, setSubmittedFeedbackBad] = useState({});
useEffect(() => {
  console.log("feedbackComment",feedbackComment)
},[feedbackComment])
  useEffect(() => {

    const initialIconStates = {};
    let combinedArray
    if(chatData.updateChat.length > 0){
      combinedArray = chatData.updateChat.concat(responses);
    }

    else{
      combinedArray = responses
    }
    console.log("combinedArray",combinedArray)
   
    combinedArray.forEach((_, index) => {
    
      console.log("chatbot index",index)
      if(index){
        initialIconStates[index] = iconStates[index] || { up: thumbsUp, down: thumbsDown };
      }

      else{
        initialIconStates[index] = iconStates[index] || { up: thumbsUp, down: thumbsDown };
      }
      
    });
    setIconStates(initialIconStates);
  }, [messages1,chatData.updateChat,responses]);

  const [iconStatesChatHistory, setIconStatesChatHistory] = useState({});
  useEffect(() => {
    console.log("chatHistory",chatHistory)
    if (Array.isArray(chatHistory)) {
      const initialIconStates = {};
      chatHistory.forEach((_, index) => {
        initialIconStates[index] = { up: thumbsUp, down: thumbsDown };
      });
      setIconStatesChatHistory(initialIconStates);
    } else {
      console.warn("chatHistory is not an array:", chatHistory);
    }
  }, [chatHistory]);


async function createFeedback(index, flag) {

  if (!submittedFeedback[index]) {
  
    setFlagValue(flag)
    if(flag == 1){
     
      setFeedbackComment({ isFeedbacked: false, id: index });
        addComment("", index,1)
     
    }

    else{
      setTimeout(() => {
        setFeedbackComment({ isFeedbacked: true, id: index });
      }, 400);
    }
   
    
    if (submittedFeedback[index] == true && flag == 1) return; // Thumbs Up already clicked
    if (submittedFeedback[index] == false && flag == 0) return; // Thumbs Down already clicked
    try {
   
      const updatedFeedback = { ...feedbackState };
  console.log("index in feedback",index)
  setSubmittedFeedback(prev => ({ ...prev, [index]: true }));
      if (flag === 1) { // Thumbs Up
        setCurrentUpImage(true)
        console.log("in flag no 1",index)
        updatedFeedback[index] = { up: true, down: false };
        setIconStates(prev => {
          const updated = { ...prev };
          updated[index] = { up: thumbsUpVote, down: thumbsDown }; // Change to thumbs up vote
         
          return updated;
        });
  
        setIconStatesChatHistory(prev => ({
          ...prev,
          [index]: { up: thumbsUpVote, down: thumbsDown } // Update thumbs up for the clicked index
        }));
  
        // setSubmittedFeedback(prev => ({ ...prev, [index]: true })); // Mark this index as submitted
  
  
      } else { // Thumbs Down
        setCurrentDownImage(true)
        console.log("in flag no 2")
        updatedFeedback[index] = { up: false, down: true };
        setIconStates(prev => {
          const updated = { ...prev };
          updated[index] = { up: thumbsUp, down: thumbsDownVote }; // Change to thumbs down vote
          // Reset other icons in the same index to thumbsUp
          for (let i = 0; i < message1.length; i++) {
            if (i !== index) {
              updated[i].down = thumbsDown;
            }
          }
          return updated;
        });
  
        setIconStatesChatHistory(prev => ({
          ...prev,
          [index]: { up: thumbsUp, down: thumbsDownVote } // Update thumbs down for the clicked index
        }));
  
        // setSubmittedFeedback(prev => ({ ...prev, [index]: false })); // Mark this index as submitted
  
      }
  
     
      setFeedbackState(updatedFeedback);
      console.log("currentUpImage", currentUpImage);
  
    } catch (error) {
      console.error("Error:", error);
    }
  }
  
}

async function createPreviousFeedback(index, flag) {
 
  if (chatHistory[index].feedback_score == "") {
    console.log("in create feedback function")
    setFlagValue(flag)
 
    setTimeout(() => {
      setFeedbackComment({ isFeedbacked: true, id: index });
    }, 400);
    
    if (submittedFeedback[index] == true && flag == 1) return; // Thumbs Up already clicked
    if (submittedFeedback[index] == false && flag == 0) return; // Thumbs Down already clicked
    try {

      const updatedFeedback = { ...feedbackState };
      console.log("index in feedback",index)
      setSubmittedFeedback(prev => ({ ...prev, [index]: true }));
      if (flag === 1) { // Thumbs Up
        setCurrentUpImage(true)
        console.log("in flag no 1",index)
        updatedFeedback[index] = { up: true, down: false };
        setIconStates(prev => {
          const updated = { ...prev };
          updated[index] = { up: thumbsUpVote, down: thumbsDown }; // Change to thumbs up vote
         
          return updated;
        });
  
        setIconStatesChatHistory(prev => ({
          ...prev,
          [index]: { up: thumbsUpVote, down: thumbsDown } // Update thumbs up for the clicked index
        }));
  
  
      } else { // Thumbs Down
        setCurrentDownImage(true)
        console.log("in flag no 2")
        updatedFeedback[index] = { up: false, down: true };
        setIconStates(prev => {
          const updated = { ...prev };
          updated[index] = { up: thumbsUp, down: thumbsDownVote }; // Change to thumbs down vote
          // Reset other icons in the same index to thumbsUp
          for (let i = 0; i < message1.length; i++) {
            if (i !== index) {
              updated[i].down = thumbsDown;
            }
          }
          return updated;
        });
  
        setIconStatesChatHistory(prev => ({
          ...prev,
          [index]: { up: thumbsUp, down: thumbsDownVote } // Update thumbs down for the clicked index
        }));
 
      }
  
     
      setFeedbackState(updatedFeedback);
      console.log("currentUpImage", currentUpImage);
  
    } catch (error) {
      console.error("Error:", error);
    }
  }
  
  else if (!submittedFeedback[index]){
    createFeedback(index)
  }
}

  useEffect(() => {
    console.log("Current Up Images:", currentUpImage);
    console.log("Current Down Images:", currentDownImage);
  }, [currentUpImage, currentDownImage]);

 
const [textareaVisible, setTextareaVisible] = useState(true);

async function addComment(value, index,flag) {

  let headers1 = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.token
    }
  };
 
  let combinedArray,id

  if(chatData.updateChat.length > 0){
    combinedArray = chatData.updateChat.concat(responses);
  }

  else{
    combinedArray = responses
  }
  
  if(chatData.chatID){
    id = chatData.chatID
  }

  if(chatId1){
    id = chatId1
  }

  let data={
    chat_id: combinedArray[index].id,
    query: combinedArray[index].query,
    answer_k: "",
    score_k: 0,
    answer_j: combinedArray[index].response,
    score_j: flag,
    comment: value

  }
  const response = await createChatFeedback(data, headers1);

  setTextareaVisible(false);
  
  setTimeout(() => {
    setCommentConfirmation(true);
  }, 500);
 
  setTimeout(() => {
    setFeedbackComment({ isFeedbacked: false, id: index });
    setTextareaVisible(true);
  }, 2000); 
 
  setTimeout(() => {
    setCommentConfirmation(false);
  }, 3000); 
}

const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update windowWidth on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <>

      <div className="main-content" style={{ paddingTop: '0rem' }}>

        {/* {windowWidth > 600 && (
             <div className="box">

             <div className="dropDown1" onMouseEnter={handleHoverDropdown}
               onMouseLeave={handleHoverDropdown}>
               {!chat.sidebarState ? <img src={edit} className='w4' style={{ border: '0.034rem 0rem 0rem 0rem', marginLeft: '1.938rem' }} /> : ''}
               <div
                 className="header"
                 type=""
                 id="dropdownMenuButton"
                 aria-expanded={isHoveredDropdown ? 'true' : 'false'}
                 style={{
                   border: 'none',
                   backgroundColor: 'white',
                   position: 'relative',
                   paddingRight: '1.25rem'
                 }}
   
               >
                 <span className="arrow-icon" style={{
                   position: 'absolute',
                   right: '-0.313rem', // Adjust as needed
                   transform: isHoveredDropdown ? 'rotate(-180deg)' : 'rotate(0deg)',
                   transition: 'transform 0.3s ease' // Smooth transition
                 }}>
                   <img className="dropdown1" src={dropdown} />
                 </span>
                 {chatData.model ? chatData.model : 'SkyElectric AI Assistant'}
               </div>
   
   
               <ul
                 className={`dropdown-menu dropdown-style ${chat.sidebarState ? 'custom-dropdown-menu1' : 'custom-dropdown-menu'} ${isHoveredDropdown ? 'show' : ''}`}
                 aria-labelledby="dropdownMenuButton"
   
               >
                 <li style={{ display: '-webkit-inline-box' }}>
                   <img src={user} className='dropdown-icons' />
                   <a className="dropdown-item custom-dropdown-text" href="#" onClick={handleSelect}>
                     SkyChat-instruct-0.1
                   </a>
                 </li>
   
                 <li style={{ display: '-webkit-inline-box' }}>
                   <img src={zap} className='dropdown-icons' />
                   <a className="dropdown-item custom-dropdown-text" href="#" onClick={handleSelect}>
                     SkyChat-r0.1
                   </a>
                 </li>
               </ul>
             </div>
   
   
           </div>
        )} */}
       

      <div className='row'>

      {(isButtonVisible && recentChat != false) &&
      <div 
    className="col-1 d-flex align-items-center justify-content-start" 
    style={{ height: '100vh', position: 'relative', zIndex: 10 }}
  >
    {/* Hover container specifically for hover area */}
    <div 
      className="hover-container" 
      onMouseEnter={handleHover} 
      onMouseLeave={handleHover}
      style={{ 
        // width:'12.5rem',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        cursor: 'pointer', 
        position: 'relative', 
        // width: '12rem', 
        height: 'fit-content', 
        zIndex: 10, // Ensure hover container is on top
        paddingLeft: '1rem'
        // marginLeft: '1rem'
        // border: '1px solid red', // Temporary border to see hover area
      }}
    >
      {isHovered ? (
        <>
          {chat.sidebarState ? (
            <>
            {/* <span >
            <img
                src={close}
                className="w1"
                style={{ float: 'left' }}
                onClick={closeSideBar}
              />
              <img
                src={closeSidebar}
                className="w2"
                style={{ float: 'left' }}
                onClick={closeSideBar}
              />
              </span> */}
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <img
                  src={close}
                  className="w1"
                  style={{ cursor: "pointer" }}
                  onClick={closeSideBar}
                  alt="Close"
                />
                <img
                  src={closeSidebar}
                  className="w2"
                  style={{ cursor: "pointer" }}
                  onClick={closeSideBar}
                  alt="Close Sidebar"
                />
              </span>

              
            </>
          ) : (
            <>
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img
                src={open}
                className="w1"
                style={{ float: 'left', zIndex: 11 }}
                onClick={closeSideBar}
              />
              <img
                src={openSidebar}
                className="w2"
                style={{ float: 'left', zIndex: 11 }}
                onClick={closeSideBar}
              />
              </span>
            </>
          )}
        </>
      ) : (
        <img
          src={line}
          className={`w3 ${chat.sidebarState ? 'lineImg' : 'lineImg'}`}
          style={{ margin: 'auto', zIndex: 11 }}
        />
      )}
    </div>
  </div>
  }
        <div className={`${chat.sidebarState ?  'col-10' : 'col-12'}`} style={{position:'fixed',bottom:'1rem'}}>
        <div className={`${isButtonVisible && recentChat != false ? 'chat' : ''}`} >

        {(isButtonVisible && recentChat != false) &&
            <>

              <div style={{ display: 'inline' }} >

                <div>
                  <div className='row' style={{marginBottom: sideBar ? '4%' : ''}}>

                    <div className='col'></div>

                    <div className='col-5' style={{ float: 'center' }}>
                      <img className="Group" src={Group} />
                      <p className='help'>
                        How can I help you today?
                      </p>
                    </div>

                    <div className='col'></div>

                  </div>

                  <div className='chatBottomMargin'> 
                    <div className={`row ${sideBar ? 'iconDiv1' : 'iconDiv2'}`}>

                      <div className='col'></div>

                      <div className={`buttonDiv ${window.innerWidth <= 600 ? 'col-11' : 'col-10'}`} >
                        <button onClick={(e) => defaultMessages(b1, e)} className=' p-0 button1'>
                          {/* <p className='buttonHead'>SmartFlow™ Artificial Intelligence</p> */}
                          <p className='buttonText'>{b1}</p>
                        </button>&nbsp;&nbsp;

                        <button onClick={(e) => defaultMessages(b2, e)} className='p-0 button1'>
                          {/* <p className='buttonHead'>NOC Installer Guide</p> */}
                          <p className='buttonText'>{b2}</p>
                        </button>
                      </div>

                      <div className='col'></div>

                    </div>

                    <div className='row' style={{ paddingTop: '3vh' }}>

                      <div className='col'></div>

                      <div className= {`buttonDiv ${window.innerWidth <= 600 ? 'col-11' : 'col-10'}`}>
                        <button onClick={(e) => defaultMessages(b3, e)} className='p-0 button1'>
                          {/* <p className='buttonHead'>Changeover Complaint</p> */}
                          <p className='buttonText'>{b3}</p>
                        </button>&nbsp;&nbsp;

                        <button onClick={(e) => defaultMessages(b4, e)} className='p-1 button1'>
                          {/* <p className='buttonHead'>Battery Capacity Issue</p> */}
                          <p className='buttonText'>{b4}</p>
                        </button>
                      </div>

                      <div className='col'></div>

                    </div>
                  </div>
                </div>
              </div>

            </>}
            
            {(!isButtonVisible && recentChat == true && isClicked == true) &&
            <>


              <div ref={combinedChatBoxRef} id="chatBox" className={`${sideBar ? 'chat-box1' : 'chat-box'}`}>
                <span className={`span1 span1-top ${sideBar ? 'span1-left3' : 'span1-left20'}`} style={{ width: '12.5rem' }}

                  onMouseEnter={handleHover}
                  onMouseLeave={handleHover}
                // onClick={handleHover}
                >
                  {/* {isHovered ? (
                    <>
                    
                          <img
                            src={close}
                            className='w1'
                            style={{ float: 'left' }}
                            onClick={closeSideBar}
                          />
                          <img
                            src={closeSidebar}
                            className='w2'
                           
                            style={{ float: 'left' }}
                            onClick={closeSideBar}
                          />
                        </>
       
                  ) : (
                    <img
                      src={line}
                      className={`w3 ${chat.sidebarState ? 'lineImg' : 'lineImg1'}`}
                    />
                  )} */}

{isHovered ? (
                  <>
                    {chat.sidebarState ? (
                      <>
                    
                    <span style={{ display: "flex", alignItems: "center",marginLeft:'0.5rem' }}>
                      <img
                        src={close}
                        className="w1"
                        style={{ float: 'left', zIndex: 11 }}
                        onClick={closeSideBar}
                      />
                      <img
                        src={closeSidebar}
                        className="w2"
                        style={{ float: 'left', zIndex: 11 }}
                        onClick={closeSideBar}
                      />
                      </span>
                      </>
                    ) : (
                      <>
                     
                        <span style={{ display: "flex", alignItems: "center",marginLeft:'0.5rem' }}>
                          <img
                            src={open}
                            className="w1"
                            style={{ cursor: "pointer" }}
                            onClick={closeSideBar}
                            alt="Close"
                          />
                          <img
                            src={openSidebar}
                            className="w2"
                            style={{ cursor: "pointer" }}
                            onClick={closeSideBar}
                            alt="Close Sidebar"
                          />
                        </span>

                      </>
                    )}
                  </>
                ) : (
                  <img
                    src={line}
                    className={`w3 ${chat.sidebarState ? 'lineImg' : 'lineImg1'}`}
                  />
                )}
                </span>


                {messages1.map((message, index) => (
                  <div key={index} className={` ${chat.sidebarState ? 'content' : 'content1'}`}>

                    <div className='clientHead'>
                      <img src={Avatar} alt="Avatar" className='avatarIcon' />
                      <span className='chatHead'>
                        You
                      </span>
                    </div>
                    <div style={{ textAlign: 'left', paddingLeft: '2.625rem', marginTop: '-0.438rem' }}>
                      {!message.fileUpload && (
                        <span className='chatText1'>
                          {message.typedValue}
                        </span>
                      )}

                      {message.buttonVal && (
                        <span className='chatText1'>
                        {message.buttonVal}
                      </span>
                      )}

                      {message.fileUpload && (
                        <div>
                          <button className='fileUpload'>
                            <img src={fileIcon} alt="Upload Icon" style={{ borderRadius: '0.5rem' }} />

                            <div style={{
                              display: 'inline-grid', alignContent: 'stretch', justifyContent: 'space-evenly',
                              alignItems: 'center', justifyItems: 'start'
                            }}>
                              <span style={{ fontWeight: '500', textAlign: 'left', fontSize: '14px', fontStyle: 'Inter', marginTop: '10px', marginLeft: '10px', marginRight: '14px' }}>&nbsp;&nbsp;{message.fileValue}&nbsp;</span>
                              <span style={{ fontWeight: '400', fontSize: '14px', fontStyle: 'Inter', marginLeft: '10px', marginBottom: '10px' }}>&nbsp;&nbsp;{message.fileSize} KB&nbsp;</span>
                            </div>

                          </button>

                          {message.typedValue && (
                            <div style={{ marginTop: '1rem' }}>
                              <span className='chatText1'>
                                {message.typedValue}
                              </span>
                            </div>
                          )}
                        </div>
                      )}

                    </div>

                      <>

                    {(responses[index]) && (
                        <p className='botHead'>
                          <img src={logoImage} className='logoIcon' />
                          <span className='chatHead'>SkyElectric Chatbot</span>
                        </p>
                      )}

                      {responses.length > index && (
                            <>
                             {!responses[index].response && (
                              <>
                               <div className='chatText2' style={{ float: 'left' }}>
                              
                                <div className="loading-wrapper">
                              
                                <span className="loading-text"><b>{responses[index].loader}</b></span>
                                <span className="loading-container">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div><br/>
                                </span>
                                
                                </div>
                                                      
                            </div>
                            <br/>
                            </>
                             )}
                             
  
           
                            </>
                          )}
                     
                         {responses[index] && !colorState[index] &&(
                        <p className='chatText2'>
                          <Markdown>{responses[index].response}</Markdown>
                        </p>
                       )} 

                      {responses[index] && colorState[index] &&(
                        <p className='chatText2' style={{ color: 'red' }}>
                          <Markdown>{responses[index].response}</Markdown>
                        </p>
                      )}

                    
                      <div className="icon-container" style={{ float: 'left', paddingLeft: '2.188rem' }}>
                      <div className="icon-wrapper">
                        <img
                          src={copyBtn}
                          // style={{marginLeft: isHovered ? window.innerWidth <= 600 ?'73%':'84%':'86%' }}
                          style={{ marginRight: '0.313rem', verticalAlign: 'top', width: windowWidth <= 910 ? '1.5rem' : '1.7rem', height: windowWidth <= 910 ? '1.5rem' : '1.7rem' }}
                          onMouseEnter={() => handleMouseEnter(index, 'copy')}
                          onMouseLeave={handleMouseLeave}
                        />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'copy' && (
                          <div className="hover-text">Copy</div>
                        )}
                      </div>

                <div className="icon-wrapper" onClick={() => createFeedback(index, 0)}  disabled={submittedFeedback[index] === true}>
                  <img src={iconStates[index]?.down} 
                      style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem' }}
                      onMouseEnter={() => handleMouseEnter(index, 'thumbsDown')}
                      onMouseLeave={handleMouseLeave} 
                    />
                      {index1 === index && hoveredButton.index === index && hoveredButton.button === 'thumbsDown' && (
                        <div className="hover-text">Bad Response</div>
                      )}
                </div>
                <div className="icon-wrapper" onClick={() => createFeedback(index, 1)} disabled={submittedFeedback[index] === true}>
                  <img src={iconStates[index]?.up} 
                      style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }} 
                      onMouseEnter={() => handleMouseEnter(index, 'thumbsUp')}
                      onMouseLeave={handleMouseLeave} />
                
                  {index1 === index && hoveredButton.index === index && hoveredButton.button === 'thumbsUp' && (
                                  <div className="hover-text">Good Response</div>
                                )}
                </div>

                      <div className="icon-wrapper">
                        <img src={speaker} style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                          onMouseEnter={() => handleMouseEnter(index, 'speaker')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => handleButtonClick(responses[index].response)} />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'speaker' && (
                          <div className="hover-text">Read Aloud</div>
                        )}
                      </div>

                      <div className="icon-wrapper">
                        <img src={refresh} style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                          onMouseEnter={() => handleMouseEnter(index, 'refresh')}
                          onMouseLeave={handleMouseLeave} />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'refresh' && (
                          <div className="hover-text">Regenerate</div>
                        )}
                      </div>
                      </div>

                      
                       
                        <br/>
                      </>
                     {feedbackComment.isFeedbacked && feedbackComment.id == index && textareaVisible &&(
                        <div style={{paddingLeft:'2.188rem'}}>
                                                
                        <form>
                          <div style={{ position: 'relative', width: '100%' }}>
                            <textarea
                              id="comment"
                              name="message"
                              placeholder="Comment here..."
                              style={{
                                border: 'none',
                                borderRadius: '1.5rem',
                                paddingLeft: '1rem',
                                paddingRight: '3rem', 
                                backgroundColor: '#F8F9FC',
                                width: '100%',
                                paddingTop: '0.5rem',
                                boxSizing: 'border-box',
                                resize: 'none',
                                maxHeight: '2.5rem',
                              }}
                              // onKeyUp={(e) => llmOutput(e.target.value, e)}
                              // onChange={handleChange}
                              // disabled={isDisabled}
                              // onKeyPress={handleKeyPress}
                            />
                            <span style={{ 
                              position: 'absolute', 
                              right: '1rem', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              cursor: 'pointer' 
                            }}>
                              
                              <div style={{marginTop:'-0.2rem'}}>
                                <button 
                                  type='button'
                                  className='commentButton'>
                                <span style={{font:'Poppins',fontSize:'12px',fontWeight:'500'}} onClick={() => { addComment(document.getElementById('comment').value,index,0)}}>
                                    Comment
                                </span> 
                                </button>
                              </div>
                              
                            </span>
                          </div>
                        </form>

                        </div>
                     )}
                    
                 
                    { feedbackComment.isFeedbacked && feedbackComment.id === index && commentConfirmation && (
                        <div style={{ fontSize: '14px', fontFamily: 'Poppins', color: '#2787C5',
                                      textAlign: 'left', marginLeft: '2.3rem' }}>
                            Comment successfully submitted
                        </div>
                    )}
                    
                  </div>
                ))}


                        {/* <p className='botHead'>
                          <img src={logoImage} className='logoIcon' />
                          <span className='chatHead'>SkyElectric Chatbot</span>
                        </p> */}


                        
                        {/* {colorState[index]==false && ( */}
                          {/* <p className='chatText2'>
                      
                          <Markdown>{response}</Markdown>
                          </p> */}
                        {/* )} */}
                        {/* {!messages[index].color && ( */}
                        {/* {colorState[index]==false && ( */}
                          <p className='chatText2'>
                          {/* <Markdown>{response}</Markdown> */}
                          </p>
                        {/* )} */}
                        
                         {/* {colorState[index]==true && (
                            <p className='chatText2' style={{ color: 'red' }}>
                            <Markdown>{response}</Markdown>
                          </p>
                         )} */}
                {/* <hr /> */}
              </div>

            </>
          }

          {recentChat == false &&
            <div ref={combinedChatBoxRef} id="chatBox" className={`${sideBar ? 'chat-box1' : 'chat-box'}`}>
              <span className={`span1 span1-top ${sideBar ? 'span1-left3' : 'span1-left20'}`} style={{ width: '12.5rem' }}

                onMouseEnter={handleHover}
                onMouseLeave={handleHover}
              // onClick={handleHover}
              >
                {isHovered ? (
                  <>
                    {chat.sidebarState ? (
                      <>
                    
                    <span style={{ display: "flex", alignItems: "center",marginLeft:'0.25rem', gap: "8px" }}>
                      <img
                        src={close}
                        className="w1"
                        style={{ float: 'left', zIndex: 11 }}
                        onClick={closeSideBar}
                      />
                      <img
                        src={closeSidebar}
                        className="w2"
                        style={{ float: 'left', zIndex: 11 }}
                        onClick={closeSideBar}
                      />
                      </span>
                      </>
                    ) : (
                      <>
                     
                        <span style={{ display: "flex", alignItems: "center", marginLeft:'0.5rem' }}>
                          <img
                            src={open}
                            className="w1"
                            style={{ cursor: "pointer" }}
                            onClick={closeSideBar}
                            alt="Close"
                          />
                          <img
                            src={openSidebar}
                            className="w2"
                            style={{ cursor: "pointer" }}
                            onClick={closeSideBar}
                            alt="Close Sidebar"
                          />
                        </span>

                      </>
                    )}
                  </>
                ) : (
                  <img
                    src={line}
                    className={`w3 ${chat.sidebarState ? 'lineImg' : 'lineImg1'}`}
                  />
                )}
              </span>
              { chatHistory.length > 0 && chatHistory.map((item, index) => (
                // <div>
                <>

                  <div className={` ${chat.sidebarState ? 'content' : 'content1'}`}>
                    <div className='clientHead'>
                      <img src={Avatar} alt="Avatar" className='avatarIcon' />
                      <span className='chatHead'>
                        You
                      </span>
                    </div>

                    <div style={{ textAlign: 'left', paddingLeft: '2.625rem', marginTop: '-0.438rem' }}>
                      <span className='chatText1'>
                        {item.query}
                      </span>
                    </div>

                    <p className='botHead'>
                      <img src={logoImage} className='logoIcon' />
                      <span className='chatHead'>SkyElectric Chatbot</span>
                    </p>
                   

                    <p className='chatText2'>
                      <Markdown>{item.response}</Markdown>
                    </p>
                    <div className="icon-container" style={{ float: 'left', paddingLeft: '2.188rem' }}>
                      <div className="icon-wrapper">
                        <img
                          src={copyBtn}
                          style={{ marginRight: '0.313rem', verticalAlign: 'top', width: windowWidth <= 910 ? '1.5rem' : '1.7rem', height: windowWidth <= 910 ? '1.5rem' : '1.7rem'  }}
                          onMouseEnter={() => handleMouseEnter(index, 'copy')}
                          onMouseLeave={handleMouseLeave}
                        />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'copy' && (
                          <div className="hover-text">Copy</div>
                        )}
                      </div>
                  
                      <div className="icon-wrapper" 
                          onClick={(e) => {
                            // Prevent the function call if the button is disabled
                            if (item.feedback_score === 0 || item.feedback_score === 1 || submittedFeedback[index] == true) return;
                            
                            createPreviousFeedback(index, 0);
                          }} >
                        <img        
                          src={
                            item.feedback_score === 0 
                              ? thumbsDownVote 
                              : iconStatesChatHistory[index]?.down          
                          }
                              style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                              onMouseEnter={() => handleMouseEnter(index, 'thumbsDown')}
                              onMouseLeave={handleMouseLeave} />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'thumbsDown' && (
                          <div className="hover-text">Bad Response</div>
                        )}
                      </div>

                      <div className="icon-wrapper" 
                       onClick={(e) => {
                        // Prevent the function call if the button is disabled
                        if (item.feedback_score === 0 || item.feedback_score === 1 || submittedFeedback[index] == true) return;
                        
                        createPreviousFeedback(index, 1);
                      }}>
                        <img 
                         
                          src={
                            item.feedback_score === 1
                            ? thumbsUpVote 
                            : iconStatesChatHistory[index]?.up 
                             
                          }
                              style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                              onMouseEnter={() => handleMouseEnter(index, 'thumbsUp')}
                              onMouseLeave={handleMouseLeave} />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'thumbsUp' && (
                          <div className="hover-text">Good Response</div>
                        )}

                      </div>

                      <div className="icon-wrapper">
                        <img src={speaker} style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem' }}
                          onMouseEnter={() => handleMouseEnter(index, 'speaker')}
                          onMouseLeave={handleMouseLeave}
                          onClick={() => handleButtonClick(item.response)} />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'speaker' && (
                          <div className="hover-text">Read Aloud</div>
                        )}
                      </div>

                      <div className="icon-wrapper">
                        <img src={refresh} style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem' }}
                          onMouseEnter={() => handleMouseEnter(index, 'refresh')}
                          onMouseLeave={handleMouseLeave} />
                        {index1 === index && hoveredButton.index === index && hoveredButton.button === 'refresh' && (
                          <div className="hover-text">Regenerate</div>
                        )}
                      </div>
                    </div>
                    <br /><br />

                    {feedbackComment.isFeedbacked && feedbackComment.id == index && textareaVisible &&(
                        <div style={{paddingLeft:'2.188rem'}}>
                                                
                        <form>
                          <div style={{ position: 'relative', width: '100%' }}>
                            <textarea
                              id="comment"
                              name="message"
                              placeholder="Comment here..."
                              style={{
                                border: 'none',
                                borderRadius: '1.5rem',
                                paddingLeft: '1rem',
                                paddingRight: '3rem', 
                                backgroundColor: '#F8F9FC',
                                width: '100%',
                                paddingTop: '0.5rem',
                                boxSizing: 'border-box',
                                resize: 'none',
                                maxHeight: '2.5rem',
                              }}
                              // onKeyUp={(e) => llmOutput(e.target.value, e)}
                              // onChange={handleChange}
                              // disabled={isDisabled}
                              // onKeyPress={handleKeyPress}
                            />
                            <span style={{ 
                              position: 'absolute', 
                              right: '1rem', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              cursor: 'pointer' 
                            }}>
                              
                              <div style={{marginTop:'-0.2rem'}}>
                                <button 
                                  type='button'
                                  className='commentButton'>
                                <span style={{font:'Poppins',fontSize:'12px',fontWeight:'500'}} onClick={() => { addComment(document.getElementById('comment').value,index,0)}}>
                                    Comment
                                </span> 
                                </button>
                              </div>
                              
                            </span>
                          </div>
                        </form>

                        </div>
                     )}
                    
                 
                    { feedbackComment.isFeedbacked && feedbackComment.id === index && commentConfirmation && (
                        <div style={{ fontSize: '14px', fontFamily: 'Poppins', color: '#2787C5',
                                      textAlign: 'left', marginLeft: '2.3rem' }}>
                            Comment successfully submitted
                        </div>
                    )}
                  </div>

                </>
              ))}

              {isClicked == true && messages1.map((message, index) => (
                //  <div key={index} style={{ width:'70%',marginLeft: '18%' }}>
                <div key={index} className={` ${chat.sidebarState ? 'content' : 'content1'}`}>
                  <div className='clientHead'>
                    <img src={Avatar} alt="Avatar" className='avatarIcon' />
                    <span className='chatHead'>
                      You
                    </span>
                  </div>

                  <div style={{ textAlign: 'left', paddingLeft: '2.625rem', marginTop: '-0.438rem' }}>
                    {!message.fileUpload && (
                      <div style={{ textAlign: 'left', marginTop: '-0.438rem' }}>
                        <span className='chatText1'>
                          {message.typedValue}
                        </span>
                      </div>
                    )}

                    {message.fileUpload && (
                      // <button className='fileUpload'>{message.value}</button>
                      <div>
                        <button className='fileUpload'>
                          <img src={fileIcon} alt="Upload Icon" style={{ width: '39px', height: '39px', borderRadius: '0.5rem' }} />

                          <div style={{
                            display: 'inline-grid', alignContent: 'stretch', justifyContent: 'space-evenly',
                            alignItems: 'center', justifyItems: 'start'
                          }}>
                            <span style={{ fontWeight: '500', textAlign: 'left', fontSize: '14px', fontStyle: 'Inter', marginTop: '10px', marginLeft: '10px', marginRight: '14px' }}>&nbsp;&nbsp;{message.fileValue}&nbsp;</span>
                            <span style={{ fontWeight: '400', fontSize: '14px', fontStyle: 'Inter', marginLeft: '10px', marginBottom: '10px' }}>&nbsp;&nbsp;{message.fileSize} KB&nbsp;</span>
                          </div>

                        </button>


                        {message.typedValue && (
                          // <div>
                          <span className='chatText1'>
                            {message.typedValue}
                          </span>
                          // </div>
                        )}
                      </div>
                    )}
                  </div>

                    <>

                    {(responses[index]) && (
                        <p className='botHead'>
                          <img src={logoImage} className='logoIcon' />
                          <span className='chatHead'>SkyElectric Chatbot</span>
                        </p>
                      )}
                       
                        
                        <p className='chatText2'>
                         
                          {responses.length > index && (
                            <>
                             {!responses[index].response && (
                              <>
                               <div style={{ float: 'left' }}>
                                <div className="loading-wrapper">
                               
                                <span className="loading-text"><b>{responses[index].loader}</b></span>
                                <span className="loading-container">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </span>
                            </div>
                           
                             </div>
                              <br/>
                              </>
                             )}
                             
                             {responses[index].response && (
                              <Markdown>{responses[index].response}</Markdown>
                             )}
                              
                            </>
                          )}
                        </p>
                       

                      <div className="icon-container" style={{ float: 'left', paddingLeft: '2.188rem' }}>
                        <div className="icon-wrapper">
                          <img
                            src={copyBtn}
                            style={{ marginRight: '0.313rem', verticalAlign: 'top', width: windowWidth <= 910 ? '1.5rem' : '1.7rem', height: windowWidth <= 910 ? '1.5rem' : '1.7rem'  }}
                            onMouseEnter={() => handleMouseEnter(index, 'copy')}
                            onMouseLeave={handleMouseLeave}
                          />
                          {index1 === index && hoveredButton.index === index && hoveredButton.button === 'copy' && (
                            <div className="hover-text">Copy</div>
                          )}
                        </div>

                        <div className="icon-wrapper" onClick={(e) => createFeedback(index+chatData.updateChat.length,0)} 
                            disabled={submittedFeedback[index+chatData.updateChat.length] == true}>
                          <img 
                              src={iconStates[chatData.updateChat.length+index]?.down} 
                              style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                              onMouseEnter={() => handleMouseEnter(index, 'thumbsDown')}
                              onMouseLeave={handleMouseLeave} />
                                {index1 === index && hoveredButton.index === index && hoveredButton.button === 'thumbsDown' && (
                                  <div className="hover-text">Bad Response</div>
                                )}
                        </div>

                        <div className="icon-wrapper" onClick={(e) => createFeedback(index+chatData.updateChat.length,1)} 
                          disabled={submittedFeedback[index+chatData.updateChat.length] == true}>
                          <img src={iconStates[chatData.updateChat.length+index]?.up}  
                                style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                            onMouseEnter={() => handleMouseEnter(index, 'thumbsUp')}
                            onMouseLeave={handleMouseLeave} />
                          {index1 === index && hoveredButton.index === index && hoveredButton.button === 'thumbsUp' && (
                            <div className="hover-text">Good Response</div>
                          )}
                        </div>

                        <div className="icon-wrapper">
                          <img src={speaker} style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                            onMouseEnter={() => handleMouseEnter(index, 'speaker')}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => handleButtonClick(responses[index].response)} />
                          {index1 === index && hoveredButton.index === index && hoveredButton.button === 'speaker' && (
                            <div className="hover-text">Read Aloud</div>
                          )}
                        </div>

                        <div className="icon-wrapper">
                          <img src={refresh} style={{ marginRight: '0.625rem', verticalAlign: 'top', width: windowWidth <= 910 ? '0.75rem' : '1rem', height: windowWidth <= 910 ? '0.75rem' : '1rem'  }}
                            onMouseEnter={() => handleMouseEnter(index, 'refresh')}
                            onMouseLeave={handleMouseLeave} />
                          {index1 === index && hoveredButton.index === index && hoveredButton.button === 'refresh' && (
                            <div className="hover-text">Regenerate</div>
                          )}
                        </div>
                      </div>
                      <br />

                      {feedbackComment.isFeedbacked && feedbackComment.id == index+chatData.updateChat.length && textareaVisible &&(
                        <div style={{paddingLeft:'2.188rem'}}>
                                                
                        <form>
                          <div style={{ position: 'relative', width: '100%' }}>
                            <textarea
                              id="comment"
                              name="message"
                              placeholder="Comment here..."
                              style={{
                                border: 'none',
                                borderRadius: '1.5rem',
                                paddingLeft: '1rem',
                                paddingRight: '3rem', 
                                backgroundColor: '#F8F9FC',
                                width: '100%',
                                paddingTop: '0.5rem',
                                boxSizing: 'border-box',
                                resize: 'none',
                                maxHeight: '2.5rem',
                              }}
                              // onKeyUp={(e) => llmOutput(e.target.value, e)}
                              // onChange={handleChange}
                              // disabled={isDisabled}
                              // onKeyPress={handleKeyPress}
                            />
                            <span style={{ 
                              position: 'absolute', 
                              right: '1rem', 
                              top: '50%', 
                              transform: 'translateY(-50%)',
                              cursor: 'pointer' 
                            }}>
                              
                              <div style={{marginTop:'-0.2rem'}}>
                                <button 
                                  type='button'
                                  className='commentButton'>
                                <span style={{font:'Poppins',fontSize:'12px',fontWeight:'500'}} 
                                    onClick={() => { addComment(document.getElementById('comment').value,index+chatData.updateChat.length,0)}}>
                                    Comment
                                </span> 
                                </button>
                              </div>
                              
                            </span>
                          </div>
                        </form>

                        </div>
                     )}
                    
                 
                    { feedbackComment.isFeedbacked && feedbackComment.id === index+chatData.updateChat.length && commentConfirmation && (
                        <div style={{ fontSize: '14px', fontFamily: 'Poppins', color: '#2787C5',
                                      textAlign: 'left' }}>
                            Comment successfully submitted
                        </div>
                    )}
                    </>
                  {/* )} */}
                </div>
              ))}

            </div>

          }

              </div>
                {overflowRef.current &&
                  <div className="hr-container">
                    <hr className="hr-fade" />
                  </div>
                }

                  <div className='row ' style={{ zIndex: '1000',  }}>
                  {/* <div className='row'> */}
                  {/* <div class="row align-items-end"> */}
                    <div className="col">
                    
                    </div>
                    <div className={`${window.innerWidth <= 910 ? 'col-7' : 'col-6'}`} style={{marginLeft:'2rem'}}>
                    <form
                          className="form1 input-box"
                          onSubmit={(e) => {
                            if (isDisabled) {
                              e.preventDefault(); // Prevent form submission
                              // Optionally show a message to the user
                              return; 
                            }
                            handleSubmit(e); // Proceed with the normal submission
                          }}
                          style={{
                            // height: 'auto',
                            backgroundColor: '#F1F3F9',
                            borderRadius: '1.5rem',
                            padding: '0rem',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <div style={{ marginRight: '0.5rem',marginLeft:'1rem' }}>
                            <img
                              className="image img-responsive fileicon"
                              src={attachFile}
                              alt="Upload"
                              onClick={handleClick}
                              style={{ cursor: 'pointer' }}
                            />
                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={handleFileUpload}
                              style={{ display: 'none' }}
                              accept=".pdf"
                            />
                          </div>

                                   <div style={{ position: 'relative', flex: 1, width: '100%' }}>
                             
                          <textarea
                                onInput={() => auto_grow(textareaRef.current)}
                                id="user-input"
                                name="message"
                                placeholder={placeholder} 
                                value={userInput}
                                ref={textareaRef}
                                style={{fontSize: window.innerWidth <= 910 ? '0.60rem': '1rem', height: windowWidth > 600 && windowWidth < 910 ? '1rem' : windowWidth >= 910 ? '3rem' : '2rem'}}
                                className='textArea'
                                onKeyUp={(e) => llmOutput(e.target.value, e)}
                                onChange={handleChange}
                                // disabled={isDisabled}
                                onKeyPress={handleKeyPress}
                              />               
                          
 

                              {fileName && isVisible && (
                                <button
                                  ref={fileUploadButtonRef}
                                  className='fileUpload'
                                  style={{
                                    position: 'absolute',
                                    top: '10px',
                                    left: '10px',
                                    zIndex: 1000,
                                    padding: '0.5rem',
                                    height: '4rem',
                                    background: '#FDFDFE',
                                    border: 'none',
                                  }}
                                >
                                  <img src={fileIcon} alt="Upload Icon" style={{ borderRadius: '0.5rem' }} />
                                  <span>{fileName}</span>
                                  <img
                                    src={cross}
                                    alt="Close Icon"
                                    style={{ width: '10px', height: '10px', cursor: 'pointer',marginLeft:'0.5rem' }}
                                    onClick={handleClose}
                                  />
                                </button>
                              )}
                          </div>

                        <span style={{ marginLeft: '0.5rem',marginRight:'1rem' }}>
                          <img
                            className="image img-responsive searchicon"
                            src={search}
                            onClick={(e) => { llmOutput(document.getElementById('user-input').value, e); handleSubmit(e); }}
                          />
                        </span>
                        </form>
                       
            </div>
            <div className="col">
              
            </div>
    {/* </div> */}
          {/* </div> */}
         
          <div className='row'>
            <div className='col'></div>
            <div className={`precautionText ${window.innerWidth <= 910 ? 'col-8' : 'col-6'}`} style={{marginLeft:'4rem'}}>
           
              Our chatbot can make mistakes. Consider checking important information. Read our Terms and Privacy policy.
            </div>
            <div className='col'></div>
          </div>
        </div>
        </div>

        <div className='col-1'></div>
      </div>
      
     
      </div>
    </>


  )
}

